var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text" },
    [
      _c(
        "el-collapse",
        { attrs: { value: "0" } },
        [
          _c(
            "el-collapse-item",
            {
              attrs: { name: _vm.collapsed },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function() {
                    return [
                      _c(
                        "span",
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.title) + "\n          "
                          ),
                          _vm.description
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    content: _vm.description,
                                    placement: "top",
                                    effect: "dark"
                                  }
                                },
                                [_c("i", { staticClass: "el-icon-info" })]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c("div", { staticClass: "body" }, [_vm._t("default")], 2)
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d3be1aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d3be1aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Collapse/CollapseChild.vue
// module id = null
// module chunks = 